import { render } from "./HomeDeveloper.vue?vue&type=template&id=08e8d917&scoped=true"
import script from "./HomeDeveloper.vue?vue&type=script&lang=js"
export * from "./HomeDeveloper.vue?vue&type=script&lang=js"

import "./HomeDeveloper.vue?vue&type=style&index=0&id=08e8d917&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e8d917"]])

export default __exports__